import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/sharedDownloadStates";
import deltas from "../../actions/deltas";

const {SET_DOWNLOAD_ALL_TRANSACTIONS_STATE} = deltas.actionTypes;

export default createStateReducer(states, null, SET_DOWNLOAD_ALL_TRANSACTIONS_STATE);

export const selectIsLoadingDownloadAllTransactions = (state) => states.LOADING === state.states.downloadAllTransactions.state;
